module.exports = __webpack_public_path__ + "static/img/connect.9acd8a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/connect.png
// module id = kQvw
// module chunks = 1